$(function () {
    let $filterLocation = $('.filter-location');

    function processLocation(location) {
        const params = new URLSearchParams(location.search);

        const pathLocation = params.get('location');
        if (pathLocation) {
            $filterLocation.val(pathLocation);
            filter['location'][filter.activeTab()] = [pathLocation];
            filter.params.set('location', pathLocation);
        } else {
            $filterLocation.val('');
            filter['location'][filter.activeTab()] = [];
            filter.params.delete('location');
        }

        const pathClassType = params.get('classType');
        if (pathClassType) {
            $('.filter-classType').val(pathClassType);
            filter['classType'][filter.activeTab()] = [pathClassType];
            filter.params.set('classType', pathClassType);
        } else {
            $('.filter-classType').val('');
            filter['classType'][filter.activeTab()] = [];
            filter.params.delete('classType');
        }

        const pathInstructor = params.get('instructor');
        if (pathInstructor) {
            $('.filter-instructor').val(pathInstructor);
            filter['instructor'][filter.activeTab()] = [pathInstructor];
            filter.params.set('instructor', pathInstructor);
        } else {
            $('.filter-instructor').val('');
            filter['instructor'][filter.activeTab()] = [];
            filter.params.delete('instructor');
        }

        const pathTerms = params.get('terms');
        if (pathTerms) {
            $('.search-input').val(pathTerms);
            filter['terms'][filter.activeTab()] = [pathTerms];
            filter.params.set('terms', pathTerms);
        } else {
            $('.search-input').val('');
            filter['terms'][filter.activeTab()] = [];
            filter.params.delete('terms');
        }

        filter.runFilter();
        console.log('process location: ', params, pathLocation, pathClassType, pathInstructor, pathTerms);
    }


    if ($filterLocation.length) {
        let filter = {
            params: new URLSearchParams(location.search),
            location: [],
            classType: [],
            instructor: [],
            terms: [],

            activeTab: function () {
                return $('.tab-title.active').data('slug');
            },

            populateTerms: function () {
                let activeTab = filter.activeTab();
                let tabTerms = $('#' + activeTab + ' .search-input').val();
                filter.setFilter('terms', tabTerms);
            },

            setTabUrl: function (slug) {
                history.pushState({}, '', location.origin + `/schedule/${slug}` + location.hash);
            },

            setUrl: function () {
                if (filter.params.toString()) {
                    history.pushState({}, '', location.origin + location.pathname + '?' + filter.params.toString() + location.hash);
                } else {
                    history.pushState({}, '', location.origin + location.pathname + location.hash);
                }
            },

            setFilter: function (f, value) {
                let activeTab = filter.activeTab();
                filter[f][activeTab] = value;
                if (value) {
                    filter.params.set(f, value);
                } else {
                    filter.params.delete(f);
                }
                filter.setUrl();
                filter.runFilter();
            },

            clearFilters: function () {
                $filterLocation.val('');
                filter['location'][filter.activeTab()] = [];
                filter.params.delete('location');

                $('.filter-instructor').val('');
                filter['instructor'][filter.activeTab()] = [];
                filter.params.delete('instructor');

                $('.filter-classType').val('');
                filter['classType'][filter.activeTab()] = [];
                filter.params.delete('classType');

                $('.search-input').val('');
                filter['terms'][filter.activeTab()] = [];
                filter.params.delete('terms');

                filter.runFilter();
            },

            runFilter: function () {
                let activeTab = filter.activeTab();
                let data = {
                    location: this.location[activeTab],
                    classType: this.classType[activeTab],
                    instructor: this.instructor[activeTab],
                    terms: this.terms[activeTab],
                    activeTab: activeTab
                };

                console.log(activeTab);
                // Append CSRF Token
                data[window.csrfTokenName] = window.csrfTokenValue;
                /*
                $.post('/actions/businessLogic/schedule/filterActivities', data, function (results) {
                    $('#' + activeTab + ' table tbody tr:not(:last)').remove();
                    $(results).insertBefore('#' + activeTab + ' tr.last');
                    // Refresh tooltips
                    $(document).foundation('tooltip', 'reflow');
                });
                */

                $.get('/ajax-schedule', data, function (results) {
                    var tbody = 'tbody#sched-' + activeTab;
                    console.log('ajax schedule: ', results);
                    $(tbody).empty();
                    $(tbody).append(results);
                })
            }
        };

        window.filter = filter;

        // Change location
        $filterLocation.on('change', function () {
            filter.setFilter('location', this.value);
        });

        // Change classType
        $('.filter-classType').on('change', function () {
            filter.setFilter('classType', this.value);
        });

        // Change instructor
        $('.filter-instructor').on('change', function () {
            filter.setFilter('instructor', this.value);
        });

        // Change page tabs
        $('.tab-title').on('click.tab-change', function () {
            filter.setTabUrl($(this).data('slug'));
            filter.clearFilters();
        });

        // Change terms
        $('.search-input')
            .on('blur', function () {
                filter.populateTerms();
            })
            .on('keypress', function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    filter.populateTerms();
                }
            });

        processLocation(window.location);
        window.addEventListener('popstate', (event) => {
            processLocation(window.location);
        });
    }
});